import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bos_access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const ws = localStorage.getItem("bos_workspace_id");
  if (ws) {
    config.headers["X-Workspace-Id"] = ws;
  }
  return config;
});

// Endpoints that must never trigger the global 401→/login redirect. These are
// public auth endpoints whose 401s the caller (LoginPage, SignupPage,
// AuthCallback) needs to catch and surface itself.
const PUBLIC_AUTH_ENDPOINTS = [
  "/auth/login",
  "/auth/register",
  "/auth/google/session",
  "/auth/me",
  "/super-admin/login",
];

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const url = err?.config?.url || "";
      const isPublicAuth = PUBLIC_AUTH_ENDPOINTS.some((p) => url.endsWith(p));
      const inOAuthCallback = window.location.hash?.includes("session_id=");
      const p = window.location.pathname;
      // Only force-redirect for expired sessions on already-authenticated app
      // routes. Skip the redirect while we're in the middle of an OAuth
      // callback, or when the failing request is one of the public auth
      // endpoints — the caller will handle those errors.
      if (p.startsWith("/app") && !isPublicAuth && !inOAuthCallback) {
        localStorage.removeItem("bos_access_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
